import { useQuery } from '@tanstack/react-query';
import { useBffClient } from './client';
import type { NerCategoryOption } from '../types/policy';

export function useNerCategories() {
  const client = useBffClient();
  return useQuery({
    queryKey: ['ner-categories'],
    queryFn: () => client.get<NerCategoryOption[]>('/bff/ner-categories'),
    staleTime: Infinity,
  });
}
